import { tns } from 'tiny-slider'

(() => {
    const hero = document.querySelector('.hero')

    if(!hero) return

    let autoplay = false
    let param = hero.dataset.autoplay;
    if(param) {
        autoplay = true
    }

    tns({
        container: '.hero-slider',
        controlsContainer: document.querySelector('.hero-controls'),
        autoplay: autoplay,
        autoplayHoverPause: autoplay,
        autoplayButtonOutput: false
    })

})()
